import i18n from "@/shared/config/i18n";

/**
 * Строки арабского интерфейса (locales/ar.json) — отдельным куском, по
 * требованию: пока арабский выключен (AR_UI_ENABLED, предпросмотр), его не
 * скачивает никто, и /ar берёт английский запасной язык i18next, как сегодня.
 * Включён — набор «ar» добавляется в i18next; чего в нём нет — английский
 * (fallbackLng: "en").
 */
const NS = "translation";

let inflight: Promise<void> | null = null;
/** Последнее желание: включённый арабский или нет (кусок мог догрузиться уже после выключения). */
let wanted = false;

export const arabicResourcesLoaded = (): boolean => i18n.hasResourceBundle("ar", NS);

export const loadArabicResources = (): Promise<void> => {
    if (arabicResourcesLoaded()) return Promise.resolve();
    if (!inflight) {
        inflight = import("@/shared/config/locales/ar.json")
            .then((mod) => {
                const data = ((mod as { default?: unknown }).default ?? mod) as Record<string, unknown>;
                i18n.addResourceBundle("ar", NS, data, true, true);
            })
            .finally(() => {
                inflight = null;
            });
    }
    return inflight;
};

export const unloadArabicResources = (): void => {
    if (arabicResourcesLoaded()) i18n.removeResourceBundle("ar", NS);
};

/**
 * Привести набор «ar» в i18next к нужному: включить (догрузить) или убрать.
 * Набор поменялся — languageChanged, и все, кто читает t(), перерисуются.
 * Кусок не скачался (нет сети) — остаётся английский.
 */
export const syncArabicResources = async (want: boolean): Promise<void> => {
    wanted = want;
    if (want) {
        if (arabicResourcesLoaded()) return;
        try {
            await loadArabicResources();
        } catch {
            return;
        }
        // пока качалось, арабский выключили (ушли с /ar, плитка) — не оставлять набор
        if (!wanted) {
            unloadArabicResources();
            return;
        }
    } else {
        if (!arabicResourcesLoaded()) return;
        unloadArabicResources();
    }
    await i18n.changeLanguage(i18n.language);
};
